import { render } from "./CryptoStatsPanel.vue?vue&type=template&id=1951167e&ts=true"
import script from "./CryptoStatsPanel.vue?vue&type=script&lang=ts"
export * from "./CryptoStatsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__